export default __webpack_public_path__ + "static/media/slms.b74abc09.png";